import { render, staticRenderFns } from "./OrdersNew.vue?vue&type=template&id=de86623a&scoped=true"
import script from "./OrdersNew.vue?vue&type=script&lang=ts"
export * from "./OrdersNew.vue?vue&type=script&lang=ts"
import style0 from "./OrdersNew.vue?vue&type=style&index=0&id=de86623a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de86623a",
  null
  
)

export default component.exports